module.exports = __webpack_public_path__ + "img/2.7dda5b2d.svg";